import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";
import Avatar from "@mui/material/Avatar";
import {Box, Chip} from "@mui/material";

export function AlarmSeverityPill({ label, tone , isSound = false }: { label: string; tone: string, isSound?: boolean }) {
    return (
        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Chip
                label={label}
                size="medium"
                variant={"filled"}
                sx={{
                    margin: 0.5,
                    marginRight: 1.5,
                    bgcolor: `#${tone}`,
                    color: "#FFFFFF",
                    fontSize: '13px',
                    lineHeight: '18px',
                    letterSpacing: '0.16px',

                }}
            />
            {isSound && (
                <Avatar variant={"circular"} sx={{ bgcolor: `#${tone}`, width:'32px', height: '32px' }}>
                    <VolumeUpOutlinedIcon fontSize="small" sx={{ width: '18px', height: '17.54px', top: '3.23px', left: '3px', color: "#FFFFFF" }}/>
                </Avatar>
            )}
        </Box>
    );
}

export default AlarmSeverityPill